import React from "react";
import { Listbox } from "../listbox/Listbox";
import { ListboxButton } from "../listbox/ListboxButton";
import { ListboxOption } from "../listbox/ListboxOption";
import { ListboxOptions } from "../listbox/ListboxOptions";
export function Picker({ className, options, placement = "right", value, onChange, }) {
    const selectedOption = options.find((o) => o.value === value);
    return (React.createElement(Listbox, { className: className, value: value, onChange: onChange },
        React.createElement(ListboxButton, null, selectedOption?.label),
        React.createElement(ListboxOptions, { className: placement === "left" && "right-auto left-0" }, options.map(({ ...option }) => (React.createElement(ListboxOption, { key: option.label, ...option }))))));
}
